"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaymentIntent = void 0;
const utils_1 = require("./utils");
const paymentsEndpoint = `${utils_1.endpoint}/payment-intents`;
const request = async (request, payload, opts) => {
    let body;
    try {
        body = payload ? JSON.stringify(payload) : undefined;
    }
    catch (e) {
        throw new Error('Can not serialize the payload');
    }
    const isNetworkError = (error) => {
        // Rethrow only if it's a server error 500/502/503
        return error.message.includes('HTTP error 5');
    };
    const isClientError = (error) => {
        return error.message.startsWith('HTTP error 4');
    };
    try {
        const res = await fetch(request.endpoint, {
            method: request.method,
            body,
            ...(0, utils_1.stripeEnvHeader)(opts),
        });
        const result = await res.json();
        // Promise resolved but return status is 2xx
        if (res.ok)
            return result;
        // Promise resolved but return status is not 2xx
        throw new Error(`HTTP error ${res.status}: ${result.message || res.statusText}`);
    }
    catch (e) {
        console.error('Error in request', e);
        if (e instanceof TypeError || e.message.includes('Failed to fetch'))
            throw new Error('Network error: ' + e.message);
        if (isNetworkError(e)) {
            const errMessage = e.message.replace(/^HTTP error \d+\:/g, 'Error:');
            throw new Error(errMessage);
        }
        else if (isClientError(e)) {
            const errMessage = e.message.replace(/^HTTP error \d+\: /g, '');
            throw new Error(`There was a problem with your request. Please check your data and try again. ${errMessage}`);
        }
        throw e;
    }
};
async function createPaymentIntent(data, opts) {
    const payload = (0, utils_1.createPaymentIntentDataToPayload)(data);
    return request({ endpoint: paymentsEndpoint, method: 'POST' }, payload, opts);
}
exports.createPaymentIntent = createPaymentIntent;
